module.exports = __webpack_public_path__ + "img/ifmsys.6ecefb5b.svg";